import React, { useEffect, useState } from 'react';
import { Footer, GlobalFilter, Navbar, Sidebar, ThemeSettings } from './components';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useStateContext } from './contexts/ContextProvider';
import 'react-simple-toasts/dist/theme/dark.css';
import 'react-simple-toasts/dist/theme/failure.css';
import Dashboard from './pages/Dashboard';
import Alerts from './pages/Alerts';
import Categories from './pages/Categories';
import Users from './pages/Users';
import Signin from './pages/Signin';
import { IdleTimerProvider } from 'react-idle-timer';
import { useCategories } from './hooks/useCategories';

export const App = () => {
	const [initialize, setInitialize] = useState(true);
	const {
		setCurrentColor,
		currentMode,
		setCurrentMode,
		activeMenu,
		themeSettings,
		currentUser,
		setCurrentUser,
		setCategories
	} = useStateContext();

	useEffect(() => {
		const currentThemeColor = localStorage.getItem('colorMode');
		const currentThemeMode = localStorage.getItem('themeMode');
		if (currentThemeColor && currentThemeMode) {
			setCurrentColor(currentThemeColor);
			setCurrentMode(currentThemeMode);
		}

		const storedUser = localStorage.getItem('user');
		if (storedUser) {
			setCurrentUser(JSON.parse(storedUser));
		}

		setInitialize(false);
	}, []);

	const { loading: categoriesLoading } = useCategories();


	if (initialize || categoriesLoading) return <div className="flex justify-center items-center h-screen">Chargement...</div>;


	return (
		<div className={currentMode === 'Dark' ? 'dark' : ''}>
			{currentUser ? (
				<BrowserRouter>
					<div className='flex relative dark:bg-main-dark-bg'>
						{activeMenu ? (
							<div className='w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white z-10'>
								<Sidebar />
							</div>
						) : (
							<div className='w-0 dark:bg-secondary-dark-bg'>
								<Sidebar />
							</div>
						)}
						<div
							className={
								activeMenu
									? 'dark:bg-main-dark-bg bg-main-bg min-h-screen md:ml-72 w-full'
									: 'bg-main-bg dark:bg-main-dark-bg w-full min-h-screen flex-2'
							}
						>
							<div className='fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full'>
								<Navbar />
							</div>
							<div>
								<GlobalFilter />
								{themeSettings && <ThemeSettings />}
								<IdleTimerProvider
									timeout={30 * 60 * 1000}
									onIdle={() => {
										localStorage.clear();
										setCurrentUser(null);
									}}
									debounce={500}
								>
									<Routes>
										<Route path='/' element={<Dashboard />} />
										<Route path='/dashboard' element={<Dashboard />} />
										<Route path='/alerts' element={<Alerts />} />
										<Route path='/categories' element={<Categories />} />
										<Route path='/users' element={<Users />} />
									</Routes>
								</IdleTimerProvider>
							</div>
							<Footer />
						</div>
					</div>
				</BrowserRouter>
			) : (
				<Signin />
			)}
		</div>
	);
};

export default App;